import React from 'react';
import './paws.css';

const Paws = () => {
    return(
        <div className="big-container">
            <div className="container">
                <div class="paw-print-1">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>
                    
                <div class="paw-print-2">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>    
                    
                <div class="paw-print-3">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>    
                    
                <div class="paw-print-4">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>
                    
                <div class="paw-print-5">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>
                    
                <div class="paw-print-6">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>
                    
                <div class="paw-print-7">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>

                <div class="paw-print-8">
                    <div class="pad large"></div>
                    <div class="pad small-1"></div>
                    <div class="pad small-2"></div>
                    <div class="pad small-3"></div>
                    <div class="pad small-4"></div>
                </div>
            </div>
        </div>

    )
}

export default Paws;